<script setup>
import BradleyLogoIcon from './bradley-logo-icon.vue'
</script>

<template>
  <div class="bradley-header text-center">
    <h1 class="bradley-header__title font-hellix text-xl font-[450] leading-tight text-[#0000CC]">
      <span>{{ $t('newBradley.header.titlePrefix') }}</span>
      <bradley-logo-icon
        class="bradley-header__logo"
        :height="22"
      />
    </h1>
    <div class="bradley-header__copy">
      <p class="bradley-header__subtitle font-inter text-sm font-normal leading-[163%] text-[#7A7A93]">
        {{ $t('newBradley.header.subtitle') }}
      </p>
      <p class="bradley-header__description font-inter text-sm font-normal leading-[163%] text-[#7A7A93]">
        {{ $t('newBradley.header.description') }}
      </p>
    </div>
  </div>
</template>

<style scoped>
.bradley-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.bradley-header__title {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  margin: 0;
}

.bradley-header__logo {
  color: #0000cc;
}

.bradley-header__copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
}

.bradley-header__subtitle,
.bradley-header__description {
  margin: 0;
  max-width: 36rem;
}
</style>
